export default __webpack_public_path__ + "static/media/logoTransparent.966dce0d.png";